import { api } from 'src/api/axios';

export interface Plan {
    id: number;
    createdAt: string;
    updatedAt: string;
    subscriptionId: number;
    planId: number;
    priceId: number;
    status: number;
}

export interface Subscription {
  id: number;
  createdAt: string;
  updatedAt: string;
  userId: number;
  applicationId: string;
  status: number;
  plans: Plan[];
}

export interface Member {
  id: number;
  createdAt: string;
  updatedAt: string;
  firstName: string;
  lastName: string;
  midName: string;
  email: string;
  phone: string | null;
  role: number;
  status: number;
  deletedAt: string | null;
  groupId: string;
  subscriptions: Subscription[];
}

export interface MemberResponse {
  data: Member[];
  pagination: {
    hasNextPage: boolean;
    total: number;
  }
}

export interface Applicant {
  applicant: number;
  firstName: string;
  lastName: string;
  gender: string;
  dob: string;
  nicotine: boolean;
  weight: number;
  heightFt: number;
  heightIn: number;
}

export interface DetailedPlan {
  id: number;
  createdAt: string;
  updatedAt: string;
  subscriptionId: number;
  planId: number;
  priceId: number;
  status: number;
  applicants: Applicant[];
  canceledAt: string | null;
  startAt: string;
  endAt: string;
}

export interface DetailedSubscription {
  id: number;
  createdAt: string;
  updatedAt: string;
  userId: number;
  applicationId: string;
  status: number;
  stripeId: string;
  activatedAt: string;
  canceledAt: string | null;
  pastDueAt: string | null;
  unpaidAt: string | null;
  deletedAt: string | null;
  plans: DetailedPlan[];
}

export interface ApplicationApplicant {
  applicant: number;
  firstName: string;
  lastName: string;
  midName?: string;
  gender: string;
  dob: string;
  nicotine: boolean;
  weight: number;
  heightFt: number;
  heightIn: number;
}

export interface ApplicationPlan {
  id: number;
  priceId: number;
  applicants: number[];
}

export interface PHQ {
  treatment: boolean;
  invalid: boolean;
  pregnancy: boolean;
  disclaimer: boolean;
  signature: string;
  effectiveDate: string;
  medications: any[];
  issues: any[];
  conditions: any[];
}

export interface ApplicationPayload {
  applicants: ApplicationApplicant[];
  income: string;
  address: any;
  plans: ApplicationPlan[];
  phq: PHQ;
}

export interface Application {
  id: string;
  createdAt: string;
  updatedAt: string;
  payload: ApplicationPayload;
}

export interface MemberByIDResponse {
  id: number;
  createdAt: string;
  updatedAt: string;
  firstName: string;
  lastName: string;
  midName: string | null;
  email: string;
  phone: string | null;
  role: number;
  status: number;
  deletedAt: string | null;
  groupId: string;
  subscriptions: DetailedSubscription[];
  applications: Application[];
}

export interface MemberListDto {
  search?: string;
  groupId?: string;
  offset?: number;
  limit?: number;
  column?: 'id' | 'firstName' | 'lastName' | 'createdAt' | 'updatedAt';
  order?: 'asc' | 'desc';
}

export const membersService = {
  list: async (payload: MemberListDto): Promise<MemberResponse> => {
    const res = await api.get('/members', { params: payload });
    return res.data;
  },

  getById: async (id: number | string): Promise<MemberByIDResponse> => {
    const res = await api.get(`/members/${id}`);
    return res.data;
  },
};
